<template>
    <div id="carousel-drag" class="carousel-draggable px-20">
        <slot name="items" />
    </div>
</template>

<script>
import SlideBehavior from "./utils/SlideBehavior.js"

export default {
    mixins:[SlideBehavior],
}
</script>

<style lang="postcss" scoped>
.carousel-draggable {
    cursor: grab;
    max-width: 60vw;

    @media (max-width: 768px) {
        max-width: 90vw;
    }

    overflow: auto;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */

    @apply flex space-x-10 md:space-x-20;

    &::-webkit-scrollbar {
        display: none;
    }
}
</style>
